import { Component, Input, Output, EventEmitter, computed } from '@angular/core';

/**
 * Slide-in side panel that overlays the page to show record details without leaving the current view.
 */
@Component({
  selector: 'es-detail-panel',
  template: `
    @if (open) {
      <div class="fixed inset-0 z-[900]" (click)="closed.emit()">
        <div
          class="absolute top-0 right-0 h-full bg-[var(--bg-card)] border-l border-[var(--border)] shadow-2xl animate-slide-in-right overflow-auto"
          [class]="widthClass()"
          (click)="$event.stopPropagation()"
        >
          <div class="flex items-center justify-between px-6 py-4 border-b border-[var(--border)] sticky top-0 bg-[var(--bg-card)] z-10">
            <h2 class="text-lg font-semibold">{{ title }}</h2>
            <button
              class="text-[var(--text-secondary)] hover:text-[var(--text)] cursor-pointer"
              (click)="closed.emit()"
            >✕</button>
          </div>
          <div class="p-6">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    }
  `,
  styles: [`
    @keyframes slideInRight {
      from { transform: translateX(100%); }
      to { transform: translateX(0); }
    }
    .animate-slide-in-right {
      animation: slideInRight 0.25s ease-out;
    }
  `],
})
export class DetailPanelComponent {
  @Input() open = false;
  @Input() title = '';
  @Input() width: 'sm' | 'md' | 'lg' = 'md';
  @Output() closed = new EventEmitter<void>();

  widthClass = computed(() => {
    const widths = { sm: 'w-80', md: 'w-[480px]', lg: 'w-[640px]' };
    return widths[this.width];
  });
}
